import { render, staticRenderFns } from "./CartaoListaDeDados.vue?vue&type=template&id=6ccba54c&scoped=true"
import script from "./CartaoListaDeDados.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoListaDeDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoListaDeDados.vue?vue&type=style&index=0&id=6ccba54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccba54c",
  null
  
)

export default component.exports